import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { graylightColor } from 'utils/uiConstants';

export const InfoText = styled(Typography)(() => ({
  margin: '20px 0',
  textAlign: 'center',
  color: graylightColor,
}));
